<div class="divide-y divide-gray-100">
    @if(entity().created_at) {
        <app-detail-date-display title="Created" [value]="entity().created_at ?? ''" />
    }
    @if(entity().updated_at) {
        <app-detail-date-display title="Last updated" [value]="entity().updated_at ?? ''" />
    }
</div>